var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Eye_Close_1948160",
    "data-name": "noun_Eye Close_1948160",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.61,
    height: 36.607,
    viewBox: "0 0 36.61 36.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M37.251,1.354a1.23,1.23,0,0,0-1.733,0L26.7,10.176A15.274,15.274,0,0,0,19.3,8.321c-9.956,0-14.752,8.87-15.752,10.981a21.537,21.537,0,0,0,6.235,7.784L2.062,34.81l-.708.708a1.23,1.23,0,0,0,0,1.733,1.237,1.237,0,0,0,1.733,0L37.251,3.087A1.23,1.23,0,0,0,37.251,1.354Zm-23.036,21.3a6.092,6.092,0,0,1,8.443-8.443Z",
    transform: "translate(-0.997 -0.997)",
    fill: "#6b6b6b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M24.9,14.068l-1.963,1.964a5.618,5.618,0,0,1,.109,1.11,6.1,6.1,0,0,1-6.1,6.1,5.528,5.528,0,0,1-1.11-.11L13.866,25.1l-2.135,2.135a15.174,15.174,0,0,0,5.209.891c9.956,0,14.752-8.87,15.752-10.981a22.145,22.145,0,0,0-4.539-6.332Z",
    transform: "translate(1.365 1.163)",
    fill: "#6b6b6b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye_closed.4c3f209d64ae2f1fd1eba102b8b7edcc.svg";
export { ForwardRef as ReactComponent };